import { createEvent } from 'signalstory';

/** The served version file reports a version other than the one baked into this bundle. */
export interface NewVersionDeployedPayload {
  running: string;
  deployed: string;
  /** What triggered the check: startup, interval, or tab became visible. */
  reason: string;
}

/** This page was just reloaded by the version check; published once on boot. */
export interface AppVersionUpdatedPayload {
  from: string;
  to: string;
}

/**
 * A reload already happened for this deployed version but the page still runs the old bundle,
 * so reloading again would loop. The user has to close the tab and open the site again.
 */
export interface ManualReloadRequiredPayload {
  running: string;
  deployed: string;
}

export const newVersionDeployed = createEvent<NewVersionDeployedPayload>('New Version Deployed');
export const appVersionUpdated = createEvent<AppVersionUpdatedPayload>('App Version Updated');
export const manualReloadRequired = createEvent<ManualReloadRequiredPayload>('Manual Reload Required');
